import { Components } from "@mui/material/styles";
import { formLabelClasses } from "@mui/material";

export const baseComponents: Components = {
  MuiDrawer: {
    styleOverrides: {
      root: {
        display: "flex",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        maxWidth: "769px",
      },
      paper: {
        top: "unset",
        zIndex: 2,
        position: "relative",
        maxWidth: "100%",
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontWeight: 800,
        color: "#011224",
      },
      outlined: {
        textTransform: "none",
        padding: "16px 24px",
        borderRadius: "8px",
        border: "1px solid rgba(1, 18, 36, 0.08)",
        color: "#011224",
      },
      contained: {
        borderRadius: "8px",
        background: "#0573E4",
        textTransform: "none",
        padding: "16px 24px",
        color: "#FFFFFF",
        backgroundColor: "#0573E4",
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        width: "100%",
        backgroundColor: "#FFFFFF",
        ".MuiFormHelperText-root": {
          marginLeft: 0,
        },
        "&.without-label .MuiInputBase-root": {
          padding: "16px 24px",
        },
        ".Mui-error": {
          borderColor: "#F02D3A",
        },
        ".invalid-text": {
          display: "block",
          fontSize: "14px",
          fontWeight: 400,
          color: "#F02D3A",
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        left: "12px",
        fontWeight: 400,
        lineHeight: "22px",
        [`&.${formLabelClasses.focused}, &.${formLabelClasses.filled}`]: {
          color: "#808992",
          top: "14px",
          left: "12px",
          fontWeight: 400,
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        padding: "26px 24px 5px 24px",
        borderRadius: 8,
        border: "1px solid #E0E3E7",
        width: "100%",
        [`&.Mui-focused`]: {
          border: "1px solid #0573E4",
        },
        input: {
          padding: "0",
          boxShadow:
            "inset 0 0 0 1px rgba(255, 255, 255, 0), inset 0 0 0 100px rgba(255, 255, 255,1)",
        },
        "input:-internal-autofill-selected": {
          background: "transparent",
        },
        ".MuiInputAdornment-root": {
          top: "-10px",
          position: "relative",

          "@media (max-width:1000px)": {
            top: "0",
          },
        },
        fieldset: {
          display: "none",
        },
        //
        "@media (max-width:1000px)": {
          padding: "16px 10px 12px 10px",
        },
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: "24px",
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      root: {
        padding: "0",
        ".MuiSelect-select": {
          padding: "22px 0 6px 24px",
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "8px",
        "&.MuiDialog-paperFullScreen ": {
          borderRadius: 0,
        },
      },
    },
  },
};
